// src/App.js
import React, { useState, useEffect } from "react";
import "./styles.css";
import Dashboard from "./components/Dashboard";
import Devices from "./components/Devices";
import MapComponent from "./components/MapComponent";
import { getLogs } from "./utils/api"; // ✅ nur noch hier

// Leaflet Icons
import L from "leaflet";
import iosIconImg from "./assets/ios.png";
import androidIconImg from "./assets/android.png";
import defaultIconImg from "./assets/pc.png";

const iosIcon = new L.Icon({ iconUrl: iosIconImg, iconSize: [30, 30] });
const androidIcon = new L.Icon({ iconUrl: androidIconImg, iconSize: [30, 30] });
const defaultIcon = new L.Icon({ iconUrl: defaultIconImg, iconSize: [30, 30] });

function App() {
  const [activePage, setActivePage] = useState("dashboard");
  const [scans, setScans] = useState([]);

  useEffect(() => {
  getLogs()
    .then((data) => {
      const normalized = (data || []).map((s) => {
        // OS/Device aus userAgent ableiten, falls os/device fehlen
        const ua = s.userAgent || "";
        const isAndroid = /Android/i.test(ua);
        const isApple = /iPhone|iPad|Mac/i.test(ua);

        return {
          // Rohfelder
          key: s.key || null,
          scanId: s.scanId || s.scandId || s.qrCode || "unknown",
          ip: s.ip || s.sourceIp || "",
          userAgent: ua,

          // Abgeleitete / fallback Felder
          os: s.os || (isAndroid ? "Android" : isApple ? "Apple" : "Unknown"),
          device: s.device || (isApple ? "iOS" : isAndroid ? "Android" : "Desktop"),

          // Location (falls vorhanden)
          city: s.city || s.geo?.city || null,
          region: s.region || s.geo?.region || null,
          country: s.country || s.geo?.country || null,
          location:
            [s.city || s.geo?.city, s.region || s.geo?.region, s.country || s.geo?.country]
              .filter(Boolean)
              .join(", ") || "?",

          // Koordinaten (optional; viele Einträge haben keine)
          lat: s.lat ?? s.latitude ?? s.geo?.lat ?? null,
          lng: s.lng ?? s.lon ?? s.longitude ?? s.geo?.lon ?? null,

          // Zeit
          timestamp: s.timestamp || s.time || new Date().toISOString(),
        };
      });

      setScans(normalized);
      console.log("Scans geladen:", normalized.length);
    })
    .catch((err) => console.error("Fehler beim Laden der Daten:", err));
}, []);


  const renderPage = () => {
    switch (activePage) {
      case "dashboard":
        return (
          <Dashboard
            scans={scans}
            iosIcon={iosIcon}
            androidIcon={androidIcon}
            defaultIcon={defaultIcon}
          />
        );
      case "devices":
        return <Devices scans={scans} />;
      case "map":
        return (
          <MapComponent
            scans={scans}
            iosIcon={iosIcon}
            androidIcon={androidIcon}
            defaultIcon={defaultIcon}
          />
        );
      default:
        return <Dashboard scans={scans} />;
    }
  };

  return (
    <div>
      <nav className="navbar">
        <h1 className="logo">📲 Leylix - QR Tracking AdminPanel</h1>
        <div className="nav-links">
          <button onClick={() => setActivePage("dashboard")}>Dashboard</button>
          <button onClick={() => setActivePage("devices")}>Geräte</button>
          <button onClick={() => setActivePage("map")}>Karte</button>
        </div>
      </nav>
      <main className="main-content">{renderPage()}</main>
    </div>
  );
}

export default App;
